import LeftNavigationMenu from "src/components/navigation/leftNavigation/LeftNavigationMenu";
import TravelLeftNavigationMenu from "src/components/navigation/leftNavigation/TravelLeftNavigationMenu";
import TopNavigationMenu from "src/components/navigation/topNavigation/TopNavigationMenu";

export default function NavigationRouter({ workspaceDetails, activeNotifications, sidepanelWidth, menuType, isMenu, setIsMenu, menus, setMenus, simulatedMenus, setSimulatedMenus, keyword, setKeyword, handleMenuClick = () => {}, useCustomSidbar = false, customSidebarHtml = "" }) {
  return (
    <>
      {workspaceDetails?.travel_enabled && menus.length > 1 ? (
        <TravelLeftNavigationMenu
          sidepanelWidth={sidepanelWidth}
          isMenu={isMenu}
          useCustomSidbar={useCustomSidbar}
          setIsMenu={setIsMenu}
          menus={menus}
          setMenus={setMenus}
          simulatedMenus={simulatedMenus}
          setSimulatedMenus={setSimulatedMenus}
          keyword={keyword}
          setKeyword={setKeyword}
          handleMenuClick={handleMenuClick}
          activeNotifications={activeNotifications}
          customSidebarHtml={customSidebarHtml}
        />
      ) : (
        menus.length > 1 && (
          <>
            {menuType === "vertical" && (
              <LeftNavigationMenu
                sidepanelWidth={sidepanelWidth}
                isMenu={isMenu}
                useCustomSidbar={useCustomSidbar}
                setIsMenu={setIsMenu}
                menus={menus}
                setMenus={setMenus}
                simulatedMenus={simulatedMenus}
                setSimulatedMenus={setSimulatedMenus}
                keyword={keyword}
                setKeyword={setKeyword}
                handleMenuClick={handleMenuClick}
                activeNotifications={activeNotifications}
                customSidebarHtml={customSidebarHtml}
              />
            )}
            {menuType === "horizontal" && (
              <TopNavigationMenu
                isMenu={isMenu}
                setIsMenu={setIsMenu}
                menus={menus}
                setMenus={setMenus}
                simulatedMenus={simulatedMenus}
                setSimulatedMenus={setSimulatedMenus}
                keyword={keyword}
                setKeyword={setKeyword}
                handleMenuClick={handleMenuClick}
              />
            )}
          </>
        )
      )}
    </>
  );
}
